import { Box } from "@mui/material";

export default function CycleProgress({ progress }) {
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: '3px',
        backgroundColor: "rgba(255, 255, 255, 0.25)",
        overflow: "hidden",
        zIndex: 1000
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: `${Math.min(Math.max(progress, 0), 1) * 100}%`,
          background:
            "linear-gradient(90deg, rgba(255,255,255,0.9), rgba(255,255,255,0.6))",
          transition: "width 250ms linear",
        }}
      />
    </Box>
  );
}